import { useState, type FormEvent } from "react";
import { api } from "../api.js";

export function LoginPage({ onAuthenticated }: { onAuthenticated: () => void }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const submit = async (event: FormEvent) => {
    event.preventDefault(); setLoading(true); setError(null);
    try {
      await api.login(password);
      onAuthenticated();
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "Unable to sign in");
    } finally { setLoading(false); }
  };
  return <main className="login-page">
    <section className="login-card">
      <div className="login-logo">G</div>
      <div className="eyebrow">Private training log</div>
      <h1>Welcome back</h1>
      <p>Sign in to see today’s training.</p>
      <form onSubmit={submit}>
        <label>Password<input autoFocus type="password" value={password} onChange={(event) => setPassword(event.target.value)} autoComplete="current-password" /></label>
        {error && <div className="form-error">{error}</div>}
        <button className="primary-button full" disabled={loading || !password}>{loading ? "Signing in…" : "Sign in"}</button>
      </form>
    </section>
  </main>;
}
